

// Accordion Block
ready(function() {
    var accordions = findAll('.contentblock-accordion');
    if (!accordions.length)
        return;

    // iterate over accordions nodelist
    accordions.forEach(function(accordion) {
        let titles = accordion.findAll('.element > .title');

        titles.forEach((title) => {
            title.on("click", function(ev) {
                ev.preventDefault();
                var element = this.parentNode;
                var text = element.find('.text');
                if (element.classList.contains('open')) {
                    element.classList.remove('open');
                    text.slideUp();
                } else {
                    element.classList.add('open');
                    text.slideDown();
                }

            });

        });

    });



});
